import {bootstrapDirective} from './bootstrap-directive';
import {bootstrapComponent} from './bootstrap-component';
import {CookieManagement} from './cookie-management/cookie-management.component';
import {Component} from './component.interface';
import {NavSlider} from './nav-slider/nav-slider.component';
import {FocusBox} from './focus-box/focus-box.component';
import {Directive} from './directive.interface';
import {HttpClientService} from './http-client/http-client.service';
import {GlossaryService} from './glossary/glossary.service';
import {Tooltip} from './tooltip/tooltip.directive';
import {Autocomplete} from './autocomplete/autocomplete.component'

declare global {
    interface Window {
        bootstrapDirective: (directive: Directive, entryId?: string) => void;
        bootstrapComponent: (component: Component, entryId?: string) => void;
        HttpClientService: typeof HttpClientService;
        GlossaryService: typeof GlossaryService;
        Tooltip: typeof Tooltip;
        CookieManagement: typeof CookieManagement;
        NavSlider: typeof NavSlider;
        FocusBox: typeof FocusBox;
        Autocomplete: typeof Autocomplete;
    }
}

// Prevent obfuscating by uglifier;
window['HttpClientService'] = HttpClientService;
window['GlossaryService'] = GlossaryService;
window['Tooltip'] = Tooltip;
window['CookieManagement'] = CookieManagement;
window['NavSlider'] = NavSlider;
window['FocusBox'] = FocusBox;
window['Autocomplete'] = Autocomplete;
window['bootstrapDirective'] = bootstrapDirective;
window['bootstrapComponent'] = bootstrapComponent;